import authHelper from 'helpers/auth';

export const mandatoryFields = [
    'arrival_date',
    'booking_date',
    'departure_date',
    'order_id',
];

export const CSVFields = () => {
    const role = authHelper.getUserRole();

    // These are the default fields for all roles.
    const fields = {
        booking: [
            'product',
            'reservation_status',
        ],
        customer: [
            'customer_first_name',
            'customer_last_name',
            'customer_license_plate',
            'customer_phone',
            'customer_remarks',
            'number_of_persons',
            'return_flight_number',
        ],
        financial: [
            'currency',
            'options_price',
        ],
    };

    if (!role) {
        throw new Error('CSVFields: Role not defined');
    }

    switch (role) {
        case 'travel-admin':
            fields.financial.push(
                'administration_fee',
                'costfree_cancellation',
                'discount_amount',
                'discount_company_name',
                'discount_owner_id',
                'discount_title',
                'payment_amount_paid',
                'payment_method',
                'payment_method_status',
                'payment_status',
                'price_membership_deduction',
                'provider_price',
                'reseller_price',
                'reseller_price_total',
                'transaction_fee',
                'yield_price',
            );

            fields.customer.push(
                'customer_email',
            );

            fields.booking.push(
                'product_address',
                'product_id',
                'provider',
                'provider_id',
                'reseller_funnel',
                'reseller',
                'reseller_id',
            );
            break;
        case 'travel-provider':
            fields.financial.push(
                'provider_price',
                'provider_price_total',
            );
            break;
        case 'publisher':
            fields.financial.push(
                'administration_fee',
                'costfree_cancellation',
                'discount_amount',
                'discount_title',
                'payment_method',
                'payment_method_status',
                'payment_status',
                'price_membership_deduction',
                'reseller_price',
                'reseller_price_total',
                'transaction_fee',
            );

            fields.booking.push(
                'reseller_funnel',
            );

            fields.customer.push(
                'customer_email',
            );
            break;
        default:
            break;
    }

    return fields;
};

export default CSVFields;



// WEBPACK FOOTER //
// ./src/pages/bookings/list/actions/csv/settings.js